import { FormGroup, Label, Paragraph } from './styles/common';
import getFieldId from './getFieldId';

export function FormInputSelect({
  label,
  placeholder,
  options,
  registration,
  error,
  valid,
  disabled,
  value,
  onChange,
  paragraph,
  formGroupClassName,
  customStyle = '',
  hint,
}) {
  const fieldId = getFieldId(undefined, registration);
  const errorId = error ? `${fieldId}-error` : undefined;

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  if (registration === undefined) {
    return (
      <FormGroup className={formGroupClassName}>
        {label && <Label htmlFor={fieldId}>{label}</Label>}
        {paragraph !== undefined && <Paragraph>{paragraph}</Paragraph>}
        <select
          id={fieldId}
          className={`form-control ${error ? 'is-invalid' : ''
          } ${valid ? 'is-valid' : ''} ${customStyle}`}
          disabled={disabled ?? false}
          onChange={handleChange}
          value={value}
          aria-invalid={error ? 'true' : undefined}
          aria-describedby={errorId}
        >
          <option value="" disabled>{placeholder}</option>
          {options.map((opt, index) => (
            <option key={index} value={opt.id ? opt.id : opt}>
              {opt.id ? opt.name : opt}
            </option>
          ))}
        </select>
        <div className="invalid-feedback" id={errorId}>{error}</div>
        {hint && <p className="form-input-hint">{hint}</p>}
      </FormGroup>
    );
  }

  return (
    <FormGroup className={formGroupClassName}>
      {label && <Label htmlFor={fieldId}>{label}</Label>}
      {paragraph !== undefined && <Paragraph>{paragraph}</Paragraph>}
      <select
        id={fieldId}
        className={`form-control ${error ? 'is-invalid' : ''
        } ${valid ? 'is-valid' : ''} ${customStyle}`}
        disabled={disabled ?? false}
        {...registration}
        onChange={(e) => {
          registration.onChange(e);
          // Picking an option in a <select> is a definitive commit — mark it
          // touched right away (onTouched mode) so the valid/invalid state
          // updates immediately instead of only after the field is blurred.
          // RHF's onChange/onBlur are the same handler; it keys off
          // event.type, so hand it a blur-typed synthetic event.
          registration.onBlur({
            type: 'blur',
            target: { name: registration.name, value: e.target.value },
          });
        }}
        value={value}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={errorId}
      >
        <option value="" disabled>{placeholder}</option>
        {options.map((opt, index) => (
          <option key={index} value={opt.id ? opt.id : opt}>
            {opt.id ? opt.name : opt}
          </option>
        ))}
      </select>
      <div className="invalid-feedback" id={errorId}>{error}</div>
      {hint && <p className="form-input-hint">{hint}</p>}
    </FormGroup>
  );
}
